import { useOrgProjectRouteContext } from "@/lib/org-project-context/hooks";
import { useGetUsage, useSuspenseGetSubscription } from "../../api/hooks";
import type { Price } from "../../types";
import { slugify, transformUsageData } from "../../utils";
import { UsageAllocationsCard } from "./usage-allocations-card";

export const UsageAllocationsSection = () => {
  const { organizationId } = useOrgProjectRouteContext();

  const { data: subscription } = useSuspenseGetSubscription(organizationId);

  const billingPeriodStart = subscription?.current_billing_period_start_date;
  const billingPeriodEnd = subscription?.current_billing_period_end_date;

  const { data: cumulativeUsageData } = useGetUsage(organizationId, {
    view_mode: "cumulative",
    timeframe_start: billingPeriodStart,
    timeframe_end: billingPeriodEnd,
  });

  const usageMetrics = Array.isArray(cumulativeUsageData)
    ? cumulativeUsageData
    : [];

  const plan = subscription?.plan;

  const allocations = (plan?.prices ?? [])
    .filter(
      (price: Price) =>
        price.price_type === "fixed_price" &&
        price.credit_allocation &&
        price.fixed_price_quantity !== undefined &&
        price.fixed_price_quantity !== null
    )
    .map((price: Price) => ({
      name: price.item.name,
      quantity: price.fixed_price_quantity,
      currency: price.credit_allocation?.currency,
    }));

  const metricKeys = usageMetrics.map((metric) =>
    slugify(metric.billable_metric.name)
  );

  const transformedUsage = usageMetrics.length
    ? transformUsageData(usageMetrics, metricKeys)
    : [];

  return (
    <UsageAllocationsCard
      allocations={allocations}
      metricKeys={metricKeys}
      planName={plan?.name ?? "Unknown"}
      transformedUsage={transformedUsage}
    />
  );
};
